import { Component, inject } from '@angular/core';

import { ConfigurationService } from '@bytel/checkout';

import { AppService } from '@services/app.services';

import { ModalComponent } from '@shared/modal/modal.component';

@Component({
    selector: 'checkout-customer-byou-error-modal',
    templateUrl: './byou-error-modal.component.html',
    styleUrl: 'byou-error-modal.component.scss',
    imports: [ModalComponent],
    standalone: true,
})
export class ByouErrorModalComponent extends ModalComponent {
    title: string = "Quelque chose nous empêche d'afficher cette page";
    tagEventImp: Record<string, string> = {
        nomClic: 'Affichage_modale_erreur_byou',
        categorieClic: 'Modale_erreur_byou',
    };
    tagEventCTA: Record<string, string> = {
        nomClic: 'Recommencer',
        categorieClic: 'Modale_erreur_byou',
    };
    tagEventClose: Record<string, string> = {
        nomClic: 'Fermeture',
        categorieClic: 'Modale_erreur_byou',
    };

    private configurationService = inject(ConfigurationService);
    private appService = inject(AppService);

    public ngOnInit(): void {
        this.modalRef.afterClosed.subscribe(() => {
            this.onCloseHandler();
        });
    }

    private onCloseHandler(): void {
        const url = this.configurationService.getData()?.global.origin;
        this.appService.navigateTo(url);
    }
}
